export class FiltroEscola {
	
	nome: string;
	tipo: string;
	idInstituicao: number;
}